var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB8E12",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB227",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.922,33.615c0,0.487-0.124,0.919-0.371,1.297s-0.604,0.672-1.068,0.881 c-0.466,0.21-1.012,0.314-1.639,0.314c-0.523,0-0.961-0.037-1.316-0.11c-0.354-0.073-0.723-0.201-1.105-0.384v-1.891 c0.404,0.208,0.824,0.37,1.262,0.486s0.838,0.174,1.203,0.174c0.314,0,0.546-0.054,0.693-0.163c0.146-0.109,0.22-0.25,0.22-0.422 c0-0.107-0.03-0.201-0.089-0.282c-0.059-0.08-0.154-0.162-0.285-0.244c-0.13-0.082-0.479-0.251-1.044-0.505 c-0.513-0.232-0.896-0.458-1.151-0.677c-0.257-0.219-0.447-0.469-0.57-0.752s-0.186-0.617-0.186-1.004 c0-0.724,0.264-1.288,0.79-1.692s1.249-0.606,2.17-0.606c0.813,0,1.642,0.188,2.487,0.563l-0.65,1.638 c-0.734-0.336-1.367-0.504-1.901-0.504c-0.276,0-0.476,0.048-0.602,0.145s-0.188,0.217-0.188,0.359c0,0.154,0.08,0.292,0.24,0.414 c0.158,0.122,0.591,0.344,1.297,0.666c0.676,0.305,1.146,0.631,1.41,0.98C18.789,32.646,18.922,33.085,18.922,33.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.545,28.147h2.374L24.346,36h-2.497l-2.562-7.853h2.385l1.068,3.979c0.223,0.885,0.344,1.501,0.365,1.848 c0.025-0.25,0.075-0.563,0.15-0.939s0.142-0.672,0.199-0.887L24.545,28.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.92,31.402h3.39v4.232c-0.921,0.315-1.932,0.473-3.034,0.473c-1.211,0-2.146-0.351-2.807-1.053 c-0.661-0.702-0.991-1.703-0.991-3.002c0-1.268,0.362-2.255,1.085-2.96c0.723-0.705,1.736-1.058,3.04-1.058 c0.494,0,0.96,0.046,1.399,0.139c0.438,0.094,0.82,0.212,1.146,0.355l-0.672,1.664c-0.565-0.279-1.187-0.418-1.863-0.418 c-0.619,0-1.099,0.201-1.437,0.604c-0.339,0.403-0.508,0.979-0.508,1.727c0,0.734,0.153,1.294,0.459,1.679 c0.307,0.385,0.747,0.577,1.324,0.577c0.315,0,0.604-0.03,0.87-0.091v-1.229H30.92V31.402z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileSvg);
export default __webpack_public_path__ + "static/media/icon-file-svg.f51b064e295d0b4258e001bc6b48dc37.svg";
export { ForwardRef as ReactComponent };